import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getOnlineCount, subscribeOnlineCount } from "@/lib/onlineCount";

const LABEL = {
  fr: (n) => `${n} curieux en ligne maintenant`,
  en: (n) => `${n} curious minds online now`,
  es: (n) => `${n} curiosos en línea ahora`,
  nl: (n) => `${n} nieuwsgierigen nu online`,
};

export function OnlineNow() {
  const { i18n } = useTranslation();
  const lang = (i18n.language || "fr").slice(0, 2);
  const label = LABEL[lang] || LABEL.fr;
  const [n, setN] = useState(getOnlineCount);

  useEffect(() => subscribeOnlineCount(setN), []);

  return (
    <div
      data-testid="online-now"
      className="inline-flex items-center gap-2 rounded-full border border-emerald-400/30 bg-emerald-400/10 px-3.5 py-1.5 text-xs text-emerald-200/90 whitespace-nowrap backdrop-blur-md shadow-lg"
    >
      <span className="relative flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-70 animate-ping" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
      </span>
      <span className="tabular-nums font-medium">{label(n)}</span>
    </div>
  );
}
